
import { Options, Vue } from "vue-class-component";
import { CardData } from '../models/types';
import  CardConfig  from '../models/card.model';

@Options({
  props: {
    card:{type: CardConfig,	required: true	}
  },
  computed: {
      imgStyle: function () {
                return this.card && this.card.ImageUrl !== null ? "background-image: url(" + this.card.ImageUrl + ")" : "";
            }
  }
})
export default class Card extends Vue {    
  card!: CardData;
  imgStyle!: string;

}
